export const ACCESS_TOKEN_NAME = 'access_token'
export const ACCESS_TOKEN_EXPIRED = 'access_token_exp'
export const AUTHORITIES_NAME = 'authorities'
export const USER_NAME = 'userName'
export const USER_FULL_NAME = 'fullName'
export const USER_ID = 'userId'
export const RESET_PASSWORD_REQUIRED = 'reset_password_required'
export const REDIRECT_URI_NAME = 'redirect-uri'
export const TIME_OTP_EXPIRED = 'time_otp_exp'
export const CLIENT_ID_NAME = 'client-id'
export const APP_CODE_NAME = 'app-code'
export const SYSTEMS = 'systems'
export const PROVINCE_CODE = '06'
export const PROVINCE_NAME = 'Tỉnh Bắc Kạn'
export const CLIENT_ID = '53540a1899e369108fdebdd971df28060bb38071f44a5944cc095068497efcd7'
export const IS_VERIFY_OTP_WITH_MAIL = true
export const IS_VERIFY_RECAPTCHA = false
export const CONFIG_AUTHORIZATION_CONNECT_PARTNER = false

  export const Authorities = {
  ROLE_ADMIN: 1,           /* Cấp trung ướng */
  ROLE_PROVINCE: 2,        /* Cấp tỉnh */
  ROLE_DISTRICT: 3,        /* Cấp huyện */
  ROLE_WARD: 4,            /* Cấp xã */
}


